<!--
  <button
  id="notifications"
  pButton
  class="appbar_app_buttons"
  (mouseover)="notificationHover=true"
  (mouseleave)="notificationHover=false"
  (click)="toggleOverlayPanel($event, op)"
>

  <span class="icon-with-child" *ngIf="notifyCounter > 0">
    <span class="icon-notification"></span>
    <span
      class="notification_count"
      [ngClass]="{'pulsate-fwd':(notificationCountAnimation === true && notificationHover === false)}"
      >{{notifyCounter}}</span
    >
    <!-   
<input type="number" [ngModel]="notifyCounter" (ngModelChange)="doSomething($event)" (onChange)="changeValue()" 
class="notification_count pulsate-fwd"> ->
  </span>
  <span
    class="bfx-icon-lg icon-notification"
    [ngClass]="connectionStatus === 0 || connectionStatus === 1 ? 'empty' : ' '"
    *ngIf="notifyCounter === 0"
  ></span>
</button>
-->

<bfx-icon-button
  size="sm"
  [iconClass]="iconClass"
  (action)="toggleOverlayPanel($event, op)"
></bfx-icon-button>
<!-- Add a badge if we have notifications -->
<span
  *ngIf="notifyCounter > 0"
  class="notify-counter bfx-badge-negative-bold-unsized bfx-badge-bold-xs"
  >{{notifyCounter}}</span
>
<p-overlayPanel #op appendTo="body" styleClass="bfx-notification-overlay">
  <bfx-notification-viewer [overlayPanel]="op"></bfx-notification-viewer>
</p-overlayPanel>
